import { useId } from 'react'

const StirringRod = ({
  onClick,
  active = false,
  disabled = false,
  stirring = false
}) => {
  const id = useId()

  return (
    <svg
      viewBox="0 0 40 130"
      width={35}
      height={115}
      onClick={disabled ? undefined : onClick}
      style={{
        cursor: disabled ? 'default' : onClick ? 'pointer' : 'default',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.2s ease',
        transformOrigin: '20px 60px',
        animation: stirring ? 'stir 0.3s ease-in-out infinite' : 'none'
      }}
    >
      <defs>
        {/* Glass rod gradient */}
        <linearGradient id={`rod-${id}`} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="rgba(180,210,235,0.8)" />
          <stop offset="15%" stopColor="rgba(255,255,255,0.5)" />
          <stop offset="50%" stopColor="rgba(200,225,245,0.35)" />
          <stop offset="85%" stopColor="rgba(255,255,255,0.45)" />
          <stop offset="100%" stopColor="rgba(180,210,235,0.7)" />
        </linearGradient>

        {/* Shadow */}
        <filter id={`shadow-${id}`} x="-30%" y="-5%" width="160%" height="110%">
          <feDropShadow dx="2" dy="2" stdDeviation="2" floodOpacity="0.2"/>
        </filter>
      </defs>

      {/* Active glow */}
      {active && (
        <rect
          x="8" y="5" width="24" height="105" rx="12"
          fill="none"
          stroke="var(--primary)"
          strokeWidth="2.5"
          style={{ animation: 'glow 1.5s ease-in-out infinite' }}
        />
      )}

      <g filter={`url(#shadow-${id})`}>
        {/* Glass rod body */}
        <rect
          x="14" y="8"
          width="12" height="95"
          fill={`url(#rod-${id})`}
          stroke="#7A9BB8"
          strokeWidth="2"
          rx="6"
        />

        {/* Rounded bottom */}
        <ellipse
          cx="20" cy="100"
          rx="6" ry="6"
          fill={`url(#rod-${id})`}
          stroke="#7A9BB8"
          strokeWidth="2"
        />

        {/* Rounded top */}
        <ellipse
          cx="20" cy="10"
          rx="6" ry="4"
          fill={`url(#rod-${id})`}
          stroke="#7A9BB8"
          strokeWidth="1.5"
        />
      </g>

      {/* Highlight line */}
      <line
        x1="16" y1="15" x2="16" y2="90"
        stroke="rgba(255,255,255,0.6)"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Label - larger and clearer */}
      <text
        x="20" y="122"
        fontSize="11"
        fill="var(--text-primary)"
        textAnchor="middle"
        fontWeight="600"
      >
        Stir
      </text>
    </svg>
  )
}

export default StirringRod
